import React from 'react';
import { HomeIcon, BuildingIcon, DropletIcon, ShieldIcon } from 'lucide-react';
export const Services = () => {
  const services = [{
    title: 'Residential Pressure Washing',
    description: 'Complete exterior cleaning for homes, including siding, driveways, patios, and more.',
    icon: <HomeIcon size={32} className="text-green-600" data-id="element-207" />
  }, {
    title: 'Commercial Pressure Washing',
    description: 'Professional cleaning services for businesses, storefronts, and commercial properties.',
    icon: <BuildingIcon size={32} className="text-green-600" data-id="element-208" />
  }, {
    title: 'Soft Washing',
    description: 'Gentle cleaning for delicate surfaces like roofs, stucco, and painted surfaces.',
    icon: <DropletIcon size={32} className="text-green-600" data-id="element-209" />
  }, {
    title: 'Surface Sealing',
    description: 'Protect your clean surfaces with our professional sealing services.',
    icon: <ShieldIcon size={32} className="text-green-600" data-id="element-210" />
  }];
  return <section id="services" className="bg-gray-50 py-16" data-id="element-211">
      <div className="container mx-auto px-4" data-id="element-212">
        <div className="text-center mb-12" data-id="element-213">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-214">
            Our Services
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-215">
            We provide comprehensive pressure washing services to keep your
            property looking its best.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-216">
          {services.map((service, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-217">
              <div className="mb-4" data-id="element-218">{service.icon}</div>
              <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-219">
                {service.title}
              </h3>
              <p className="text-gray-600" data-id="element-220">{service.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};